import { post } from '/api.js';

export const KEY = 'cueforge.queue';

const read = () => JSON.parse(localStorage.getItem(KEY) || '[]');
const write = (items) => localStorage.setItem(KEY, JSON.stringify(items));

export const pending = () => read();

export function enqueue(body) {
  write([...read(), body]);
}

export async function flush() {
  // Each item carries the event_id the server deduplicates on, so a retry of
  // something that already landed collapses instead of counting twice. That is
  // why a failure here can safely be retried later.
  for (const item of read()) {
    try {
      await post('/api/matches', item);
    } catch (e) {
      if (!e.status) return;        // still offline: stop, keep the queue
      // A 4xx means the server will never accept it. Dropping it is the only
      // way out of a queue that would otherwise retry forever.
    }
    write(read().filter((q) => q.event_id !== item.event_id));
  }
}
